import { Table as MantineTable, TableProps as MantineTableProps } from "@mantine/core";

import styles from "./styles.module.css";
import { ReactNode } from "react";

type TableProps = Partial<MantineTableProps> & {
  className?: string;
  children: ReactNode;
};

const Table = ({ children, className, ...props }: TableProps) => {
  return (
    <MantineTable {...props} className={`${styles.tableRoot} ${className}`}>
      {children}
    </MantineTable>
  );
};

Table.Tr = MantineTable.Tr;
Table.Th = MantineTable.Th;
Table.Td = MantineTable.Td;
Table.Tbody = MantineTable.Tbody;
Table.Thead = MantineTable.Thead;

export default Table;
